
import {
  getUserInfo, orderNum, pageVisit, getUnableNum
} from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    NavMenu
  }
})
export default class extends Vue {
  infoList: any = {} // 价格列表

  ordernumber: any = {}

  menus: any[] = [
    {
      name: '个人账户',
      isOpen: true,
      child: [
        {
          id: 1,
          name: '个人中心'
        },
        {
          id: 2,
          name: '个人信息'
        },
        {
          id: 3,
          name: '安全设置'
        },
        {
          id: 4,
          name: '地址管理'
        }
      ]
    },
    {
      name: '交易管理',
      isOpen: true,
      child: [
        {
          id: 5,
          name: '我的订单'
        },
        {
          id: 6,
          name: '售后服务'
        }
      ]
    },
    {
      name: '客户服务',
      isOpen: true,
      child: [
        {
          id: 7,
          name: '发票资质'
        }
      ]
    }
  ]

  currentIndex: number = 1

  unableNum: number = 0

  @Action('card/setCardNum') setCardNum!: Function

  created() {
    this.getUserInfo();
    this.pageVisit();
    this.getUnableNum();
  }

  async getUnableNum() {
    const res: any = await getUnableNum({
      companyId: 1
    });
    if (res.data.code === 100) {
      this.unableNum = res.data.data;
    }
  }

  goOrder(id: number) {
    this.$router.push(id !== 4 ? `/order-list?id=${id}&from=user` : '/order-list?from=user');
  }

  goExchange() {
    this.$router.push('exchange-list');
  }

  private async changeChild(index: number) {
    this.currentIndex = index;
  }

  private async getUserInfo() {
    const anchor = readCookie('anchor');
    const res: any = await getUserInfo({
      companyId: 1
    });
    this.infoList = res.data.data;
    const ordernumber: any = await orderNum({
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      companyId: 1
    });
    this.ordernumber = ordernumber.data.data;
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }
}
